import { Tabs, styled } from '@engyalo/design-system';

export const StyledTabs = styled(Tabs)`
  .MuiTabs-scroller {
    background-color: ${({ theme }) => theme.palette.common.white};
    min-height: 3.5rem;
  }
`;
